import Badge from "@/v2-backoffice-client/components/badge"
import { getInvoiceStatusDisplay } from "@/v2-backoffice-client/customer/billing/customerBilling.utils"

export type CustomerInvoiceStatusBadgeProps = {
  /** Fenerum's wire status (lic.Invoices.InvoiceStatus), e.g. "due". */
  status: string
  className?: string
}

// The ONE rendering of a Fenerum invoice status — the Billing tab's invoice
// list and the Collections board both compose this, so the same state can
// never wear two labels or colors. The pill explains itself on hover: what
// the state means and what (if anything) an operator does about it.
function CustomerInvoiceStatusBadge(props: CustomerInvoiceStatusBadgeProps) {
  const { status, className } = props

  const display = getInvoiceStatusDisplay(status)

  return (
    <Badge
      className={className}
      variant={display.variant}
      tooltip={
        <div className="flex max-w-xs flex-col gap-1">
          <p className="font-medium">{display.label}</p>
          <p className="text-muted-foreground">{display.description}</p>
          {display.action && (
            <p className="mt-1 text-muted-foreground">{display.action}</p>
          )}
        </div>
      }
    >
      {display.label}
    </Badge>
  )
}

export default CustomerInvoiceStatusBadge
